import { UserSettings } from '../models/UserSettings';

export class GetUserSettingsResponse {
  userSettings?: UserSettings;
}
